import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiTrendingDown, FiClock, FiDollarSign } = FiIcons;

const ProblemSection = () => {
  const problems = [
    {
      icon: FiTrendingDown,
      text: "Running ads but leads don't convert",
      emotion: "Watching money disappear into the void"
    },
    {
      icon: FiAlertCircle,
      text: "Leads come in but no follow-up happens",
      emotion: "Potential customers slipping away daily"
    },
    {
      icon: FiClock,
      text: "Sales depend on your personal involvement",
      emotion: "Trapped in your own business"
    },
    {
      icon: FiDollarSign,
      text: "Customers buy once and disappear forever",
      emotion: "Starting from zero every month"
    },
    {
      icon: FiAlertCircle,
      text: "Revenue feels random, stressful, and unpredictable",
      emotion: "Sleepless nights wondering where the next sale comes from"
    },
    {
      icon: FiClock,
      text: "You're busy all day… but profits don't reflect the effort",
      emotion: "Working harder but not getting richer"
    }
  ];

  return (
    <section className="py-20 bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Why Most Business Owners Are <span className="text-red-400">Stuck</span>
            </h2>
            <p className="text-xl text-gray-300 mb-4">— Even After Trying Everything</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {problems.map((problem, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-gradient-to-r from-red-900/20 to-red-800/20 border border-red-500/30 rounded-xl p-6 backdrop-blur-sm"
              >
                <div className="flex items-start space-x-4">
                  <div className="bg-red-500/20 p-3 rounded-full flex-shrink-0">
                    <SafeIcon icon={problem.icon} className="text-red-400 text-xl" />
                  </div>
                  <div>
                    <h3 className="text-white text-lg font-semibold mb-2">
                      {problem.text}
                    </h3>
                    <p className="text-red-300 text-sm italic">
                      {problem.emotion}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center bg-gradient-to-r from-blue-900/30 to-purple-900/30 border border-blue-400/30 rounded-2xl p-8"
          >
            <p className="text-2xl md:text-3xl text-white mb-4 font-semibold">
              The real problem is not marketing…
            </p>
            <p className="text-xl md:text-2xl text-yellow-400 font-bold">
              It's that your growth system is broken in 4 critical places.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;